import styled from 'styled-components';

import { Colors } from 'constants/theme';

export const P3 = styled.p`
  font-family: 'EuclidCircularB';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${Colors.grey6};
  margin: 0;
`;
